(function($) {
	'use strict';

	$(document).ready(function() {
		var $topbarContainer = $('.topbar-container');

		$(window).on('scroll', function() {
			var scroll = $(window).scrollTop();
			if (scroll > 100) {
				$topbarContainer.addClass("active");
			} else {
				$topbarContainer.removeClass("active");
			}
		});

		$('.mobile-nav-trigger').on('click', function(event) {
			event.preventDefault();
			var leftNav = $('.left-nav'),
				rightNav = $('.right-nav'),
				topBar = $('.topbar-container'),
				navBlock = $('.nav-block'),
				mobileMenu = $('.mobile-menu');

			$(this).siblings(topBar).children(navBlock).find(rightNav).toggleClass('mobile-menu-active');
			$(this).parents('body').toggleClass('overflow-x').toggleClass('overflow-hidden');

			if ($(this).hasClass('open')) {
				$(this).removeClass('open').addClass('close');
			} else {
				$(this).addClass('open').removeClass('close');
			}
		});

		var burgerBtn = document.getElementById('burgerBtn');
		if (burgerBtn) {
			burgerBtn.addEventListener('click', function() {
				document.body.classList.toggle('show-navigation');
			}, false);
		}

		var anchorLinks = document.querySelectorAll('a[href^="#"]');
		anchorLinks.forEach(function(link) {
			link.addEventListener('click', function(event) {
				event.preventDefault();
				var targetId = this.getAttribute('href').substring(1);
				var targetElement = document.getElementById(targetId);

				if (targetElement) {
					targetElement.scrollIntoView({
						behavior: 'smooth',
						block: 'start'
					});
					history.pushState(null, '', '#' + targetId);
				}
			});
		});

		$('#newsletter-popup-trigger').on('click', function(e) {
			e.preventDefault();
			$(".newsletter-popup-content").toggleClass("is-active");
		});

		$('.close-button').on('click', function(e) {
			e.preventDefault();
			$(".newsletter-popup-content").removeClass("is-active");
		});

		var $cell = $('.card');

		$cell.find('.js-expander').on('click', function() {
			var $thisCell = $(this).closest('.card');

			if ($thisCell.hasClass('is-collapsed')) {
				$cell.not($thisCell).removeClass('is-expanded').addClass('is-collapsed');
				$thisCell.removeClass('is-collapsed').addClass('is-expanded');
			} else {
				$thisCell.removeClass('is-expanded').addClass('is-collapsed');
			}
		});

		$cell.find('.js-collapser').on('click', function() {
			var $thisCell = $(this).closest('.card');
			$thisCell.removeClass('is-expanded').addClass('is-collapsed');
			$cell.not($thisCell).removeClass('is-inactive');
		});
	});
})(jQuery);
